<app-loading-overlay></app-loading-overlay>
@if (showTopBar()) {
  <app-header></app-header>
}

<main [ngClass]="getStyle()">
  <router-outlet></router-outlet>
</main>